var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-input-button',{attrs:{"active-color":_vm.toggle ? (_vm.speaking ? 'red' : '#8B0000') : '#01509F'},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggle ? _vm.endSpeechRecognition() : _vm.startSpeechRecognition()}}})}
var staticRenderFns = []

export { render, staticRenderFns }